<style lang="sass">
  .footer
    margin: 0 auto !important;
    a, h2
      color: #31404E
    .uk-panel-title
      text-transform: uppercase
      color: #8999A9
  .uk-block-secondary
    padding: 10px !important
    background-color: #31404E !important
    color: #f7f7f7
</style>

<template>
  <div class="uk-block uk-block-muted footer">

      <div class="uk-container">

          <div class="uk-grid uk-grid-match uk-align-center" data-uk-grid-margin="">
              <div class="uk-width-medium-1-4 uk-row-first">
                  <div class="uk-panel">
                    <h2 class="uk-panel-title">Product</h2>

                      <a href="https://kuza.teachable.com" target="_blank"><p>Courses</p></a>
                      <a v-link="{ path : /farms }"><p>Farm Visits</p></a>
                      <a href=""><p>Farm Inputs</p></a>
                      <a href=""><p>Starter Kits</p></a>
                   
                  </div>
              </div>
                <div class="uk-width-medium-1-4 uk-row-first">
                  <div class="uk-panel">
                    <h2 class="uk-panel-title">Your Account</h2>

                      <a href="https://kuza.teachable.com/sign_in" target="_blank"><p>Login</p></a>
                      <a href="https://kuza.teachable.com/sign_up" target="_blank"><p>Sign Up</p></a>
                      <a href=""><p>Security</p></a>
                      <a href=""><p>Terms of Service</p></a>
                      <a href=""><p>Privacy Policy</p></a>
                   
                  </div>
              </div>
                <div class="uk-width-medium-1-4 uk-row-first">
                  <div class="uk-panel">
                    <h2 class="uk-panel-title">Company</h2>

                      <a href="/about"><p>About</p></a>
                      <a href="https://blog.kuza.io" target="_blank"><p>Blog</p></a>
                      <a href="/contact"><p>Contact</p></a>
                      <a href="/press"><p>Press Kit</p></a>
                   
                  </div>
              </div>
                <div class="uk-width-medium-1-4 uk-row-first">
                  <div class="uk-panel">
                    <h2 class="uk-panel-title">Contact Us</h2>

                      <a href="tel:+254718411704"><h2>+254718411704</h2></a>
                      <a href="mailto:farm@kuza.io"><p>farm@kuza.io</p></a>
                      <a href="https://twitter.com/kuzahub" class="twitter-follow-button" data-show-count="true">Follow @kuzahub</a>
                      <p> <div class="fb-like" data-href="https://www.facebook.com/kuzahub" data-layout="button_count" data-action="recommend" data-show-faces="true" data-share="true"></div>
                      </p>
                  </div>
              </div>
              
          </div>

      </div>

  </div>
   <div class="uk-block-secondary">
      <div class="uk-container uk-text-center ">
        © 2016 Kuza.io
      </div>
  </div>
</template>


<script>

  export default {
    name: 'Footer'
  }
</script>


/** WEBPACK FOOTER **
 ** Footer.vue?5aafb05e
 **/